<template>
  <el-dialog title="当前考勤明细" :visible.sync="visible" width="600px" :append-to-body="true" center>
    <!-- 是否有排班 -->
    <!-- <template v-if="scheduleType == 'SHIFT'"> -->
    <template>
      <div class="stat-list" v-if="records && records.length > 0">
        <!-- validPunch 是否有效打卡-->
        <div v-for="(item, index) of records" :key="index" class="item-stat" :class="[item.validPunch ? '' : 'item-stat-dis']">
          <span class="name">{{ item.name }}</span>
          <span class="time">{{ item.time }}</span>
          <div class="tag" v-if="item.tags && item.tags.length>0">
						<div class="tag-gray" v-for="(tag,index) of item.tags" :key="index">
							{{ tag == 'REPAIR' ?  '补卡' : tag == 'OUTSIDE' ?  '外勤' : tag }}
						</div>
				</div>
        </div>
      </div>
      <div v-else class="none-info">暂无记录</div>
    </template>
    <!-- <div class="stat-list" > -->
    <!-- 上班状态 v-if="clockInResult.visible" -->
    <!-- <div class="item-stat">
        <span class="name">上班打卡</span>
        <span class="time">{{ clockInResult.time }}</span>
        <template v-if="clockInResult.tags && clockInResult.tags.length>0">
         <div class="tag" v-for="tag in clockInResult.tags">
          <div class="tag-gray" v-if="tag ==='OUTSIDE'">外勤</div>
          <div class="tag-orange" v-else-if="tag ==='MISSING_IN'">缺卡</div>
          <div class="tag-gray" v-else-if="tag ==='LEAVE'">请假</div>
         </div>
        </template>
      </div> -->
    <!-- <div class="item-stat" v-if="clockOutResult.visible">
        <span class="name">下班打卡</span>
        <span class="time">{{ clockOutResult.time }}</span>
        <template v-if="clockOutResult.tags && clockOutResult.tags.length>0">
        <div class="tag" v-for="tag in clockOutResult.tags">
          <div class="tag-gray" v-if="tag ==='OUTSIDE'">外勤</div>
          <div class="tag-orange" v-else-if="tag ==='MISSING_OUT'">缺卡</div>
          <div class="tag-gray" v-else-if="tag ==='LEAVE'">请假</div>
         </div>
        </template>
      </div> -->
    <!-- </div> -->
    <!-- <div v-else class="none-info">该员工当日无排班</div> -->
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="visible = false">{{ buttonText }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { formatDateTime } from "@/utils/index.js";
export default {
  name: "popDelete",
  props: {
    buttonText: {
      type: String,
      default: '关闭'
    },
  },
  data() {
    return {
      visible: false,
      clockInResult: {},
      clockOutResult: {},
      scheduleType: '',
      records: [],
    }
  },
  created() {


  },
  methods: {
    show(detail) {
      this.visible = true
      this.initeData(detail)
    },
    initeData(detail) {
      this.clockInResult = {
        ...detail.clockInResult,
        ...detail.scheduleSnapshot,

      }
      let inTime = this.clockInResult.actualTime || this.clockInResult.plannedInTime
      if (inTime) {
        this.clockInResult.time = formatDateTime(inTime, 'HH:MM')
      }
      this.clockOutResult = {
        ...detail.clockOutResult,
        ...detail.scheduleSnapshot,
      }
      let outTime = this.clockOutResult.actualTime || this.clockOutResult.plannedOutTime
      if (outTime) {
        this.clockOutResult.time = formatDateTime(outTime, 'HH:MM')
      }
      // 排班类型
      this.scheduleType = detail.scheduleSnapshot && detail.scheduleSnapshot.scheduleType
      // 其他打卡结果 信息
      const typeMap = {
						IN: '上班打卡',
						OUT: '下班打卡',
						NONE: '无效打卡',
					}
      let records = (detail.records || []).map(record => {
						
        const calculatedType = record.calculatedType || 'NONE'
        let name = record.validPunch ? typeMap[calculatedType] : '无效打卡'
        return {
          ...record,
          name,
          validPunch: record.validPunch,
          distanceMeters: record.distanceMeters,
          time: record.punchTime ? formatDateTime(record.punchTime, 'HH:MM') : '',
        }
      })
      this.records = records
    }
  }
}
</script>

<style lang="scss" scoped>
.stat-list {
  padding-left: 50px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 30px;
    top: 5px;
    bottom: 6px;
    width: 1px;
    background-color: #00B498;
  }

  .item-stat {
    line-height: 1;
    position: relative;
    display: flex;
    align-items: center;

    &::before {
      content: '';
      position: absolute;
      left: -24px;
      top: 4px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #00B498;
    }

    .name {
      font-size: 14px;
      font-weight: bold;
      color: #333;
      display: inline-block;
      padding-right: 10px;
    }

    .time {
      ont-size: 14px;
      color: #666;
      display: inline-block;
      padding-right: 10px;
    }

    .tag {
      display: inline-flex;
      margin-right: 8px;

    }

    .tag-gray {
      font-size: 12px;
      line-height: 1;
      padding: 2px 3px 4px;
      border-radius: 2px;
      background-color: gray;
      color: #fff;
    }

    .tag-orange {
      font-size: 12px;
      line-height: 1;
      padding: 2px 3px 4px;
      border-radius: 2px;
      background-color: orange;
      color: #fff;
    }
  }

  .item-stat:not(:last-child) {
    margin-bottom: 50px;
  }
  .item-stat-dis{
    .name,.time{
      color: #999;
    }
  }
}

.none-info {
  line-height: 120rpx;
  font-size: 15px;
  color: #666;
  text-align: center;
}
</style>
